module.exports = __webpack_public_path__ + "img/pack.b3e1de45.png";